import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { GetById } from '@services/UnidadeService';
import { useContext } from 'react';
import { AuthContext } from '@contexts/AuthContext';
import * as Yup from "yup";
import { Field, Formik, Form } from "formik";
import { TextField } from "formik-material-ui";
import LinearProgress from "@material-ui/core/LinearProgress";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="http://inforcfc.com.br" target="_blank">
        InforCFC
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
export interface LoginProps {
  login: string;
  senha: string;
}
const formSchema = Yup.object().shape({
  login: Yup.string().required(`Campo obrigatório`),
  senha: Yup.string().required(`Campo obrigatório`)
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
const loginInitial: LoginProps = {
  login: ``,
  senha: ``
};
export default function LoginPage() {
  const { logar } = useContext(AuthContext);
  const classes = useStyles();

  async function submit(values:LoginProps, setSubmitting) {

    const result = await logar(values.login, values.senha);
    if (!result) return;




  }
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
       <Formik
              initialValues={loginInitial}
              validationSchema={formSchema}
              onSubmit={async (values, { setSubmitting }) => {
                await submit(values, setSubmitting);
              }}
            >
              {({ submitForm, isSubmitting }) => (
                <Form
                  noValidate
                  translate="no"
                  onSubmit={submitForm}
                  className={classes.form}
                >
                 
                  <Field
                    component={TextField}
                    name="login"
                    type="text"
                    label="Usuario"
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                    autoComplete="false"
                  />
                  <br />
                  <Field
                    component={TextField}
                    name="senha"
                    type="password"
                    label="Senha"
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    
                    autoComplete="false"
                  />
                  {isSubmitting && <LinearProgress />}
                  <br />
                  <Button
                    variant="contained"
                    className={classes.submit}
                    color="primary"
                    fullWidth
                    disabled={isSubmitting}
                    onClick={submitForm}
                    type="submit"
                  >
                    Submit
                  </Button>
                </Form>
              )}
            </Formik>
        
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}